import {User} from 'Models'
import {checkApiResponseForAuth} from '@features/_common/errorHandler';


export default {
    computed: {
        isLoggedIn() {
            return User.exists() && window.location.href.indexOf('/login') < 0
        },
    },

    methods: {
        checkApiResponseForAuth(error) {
            checkApiResponseForAuth(this.$ebus, error)
        }
    }
}